import * as React from 'react';
import { OrgChart } from '../../organization/_components/OrgChart';
import { getOwner } from '../../../api/organizationClientApi';
import { getWorkgroups } from '../../../api/workgroupClientApi';
import { WorkgroupListing, OrganizationOwner } from '../../../amorg-common';
import { SingleColumnLayout } from '../../../designSystem/layouts/SingleColumnLayout';
import { PageHeader } from '../../../designSystem/PageHeader';
import { EmployeePageWrapper } from '../../_pageWrappers/EmployeePageWrapper';

// type loginMethod = 'none' |'magicLink';

export function PortalOrganizationPage(): JSX.Element
{
    return (
        <EmployeePageWrapper>
            <PortalOrganizationPageContent />
        </EmployeePageWrapper>
    );
}

function PortalOrganizationPageContent(): JSX.Element
{
    const [state, setState] = React.useState<{
        workgroupList: WorkgroupListing[];
        organizationOwner: OrganizationOwner | null;
    }>(
        {
            workgroupList: [],
            organizationOwner: null
        }
    );

    React.useEffect(() => {
        const getData = async () => {
            const workgroupList = await getWorkgroups();
            const organizationOwner = await getOwner();
            setState(
                {
                    workgroupList,
                    organizationOwner
                }
            );
        };
        getData();
    }, []);


    return (
        <>

            <SingleColumnLayout
                noDivider
                headerContainer={
                    <PageHeader headerText={`Din arbejdsmiljøorganisation`} headerStyle='primary-black' />
                }
                contentContainer={
                    <OrgChart
                        allWorkgroups={state.workgroupList}
                        organizationOwner={state.organizationOwner}
                    />
                }
            />
        </>
        
    );
}